import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Invitation } from "@/components/Invitation";
import { Details } from "@/components/Details";
import { Rsvp } from "@/components/Rsvp";
import { Footer } from "@/components/Footer";
import { MusicPlayer } from "@/components/MusicPlayer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0C10] text-zinc-100 antialiased">
      <Hero />
      <Marquee />
      <Invitation />
      <Details />
      <Rsvp />
      <Footer />
      <MusicPlayer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
